import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { resetStore } from './store/store';
import { applyTelegramThemeToDocument, onMiniAppClose } from './telegram/telegram';

applyTelegramThemeToDocument();

// Clear store when Mini App is closed to ensure fresh state on next open
onMiniAppClose(() => {
  resetStore();
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
